<template>
    <div>
        <el-table :data="machineSwitch">
            <el-table-column label="机器人" prop="name">
                <template slot-scope="scope">
                    {{parseCodeToDesc(scope.row.key,switchTypes)}}
                </template>
            </el-table-column>
            <el-table-column label="开关">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.open" active-color="#13ce66" inactive-color="#ff4949" @change="saveMachineSwitchInfo(scope.row)"></el-switch>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import api from './api';
    export default {
        name: "machineSwitch",
        data(){
          return{
              machineSwitch:[],
              switchTypes:[
                  {code:'SPREAD_ORDERS_SWITCH',desc:'铺单机器人 --铺单开关'},
                  {code:'CANCEL_ORDERS_SWITCH',desc:'铺单机器人 --撤单开关'},
                  {code:'GRAB_FIRST_ORDERS_SWITCH',desc:'铺单机器人 --抢第一单开关'},
                  {code:'REGULAR_TIME_STOCK_TRADE_SWITCH',desc:'定时操盘机器人开关'},
                  {code:'BRUSH_ORDER_SWITCH',desc:'冰山策略刷单机器人开关'},
                  {code:'REVERSE_SPREAD_ORDERS_SWITCH',desc:'反向铺单机器人开关'},
              ]
          }
        },
        created() {
            api.queryMachineSwitch().then(response =>{
                this.machineSwitch = response.data;
            })
        },

        methods:{
            saveMachineSwitchInfo(row){
                api.saveMachineSwitch({switchKey:row.key,open:row.open}).then(()=>{this.$message.success('设置成功')})
            },
            parseCodeToDesc(code,infos){
                for (let index in infos){
                    if (infos[index].code == code){
                        return infos[index].desc;
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>